import styled from 'styled-components';
import { Text } from '@make-software/tg-mini-app-ui';

export const EmptyProjectTitle = styled(Text)(({ theme }) =>
  theme.withMedia({
    color: '#FFF',
    fontSize: '16px',
    fontWeight: '700',
    letterSpacing: '-0.24px',
    lineHeight: '140%',
    fontFamily: 'Inter'
  })
);

export const EmptyProjectSubtitle = styled(Text)(({ theme }) =>
  theme.withMedia({
    color: '#A9AAAD',
    fontSize: '14px',
    fontWeight: '600',
    letterSpacing: '-0.24px',
    lineHeight: '140%',
    textAlign: 'center',
    fontFamily: 'Inter'
  })
);
